export default __webpack_public_path__ + "static/drag-light-mode-0b32529f2d313f0a85d1cfece9132b7f.mp4";